<!--
Author: Lsc
Date: 2019-08-20
Desc: 预约赎回组件
-->
<template>
    <div class="comp-order-sell comp">
        <el-form
            v-show="!sellSuccess"
            ref="fundInfo"
            :model="fundInfo"
            :rules="rules"
            label-width="260px"
            class="pwdForm"
            inline-message
            v-on:submit.native.prevent
        >
            <el-form-item label="基金名称：" class="form-text">
                <div v-cloak class="text-con">
                    {{ fund.fundname + "(" + fund.fundcode + ")" }}
                </div>
            </el-form-item>
            <el-form-item label="业务类型：" class="form-text">
                <div v-cloak class="text-con">预约赎回</div>
            </el-form-item>
            <el-form-item label="回款账号：" class="form-text">
                <div v-cloak class="text-con">
                    {{ sfund.depositacct ? sfund.depositacct : "--" }}
                </div>
            </el-form-item>
            <el-form-item label="可赎回份额：" class="form-text">
                <div v-cloak class="text-con">
                    {{ sfund.preavailbal ? sfund.preavailbal : "--" }}（份）
                </div>
            </el-form-item>
            <el-form-item label="净值日期：" class="form-text">
                <div v-cloak class="text-con">
                    {{ fund.navdate ? $util.fmtDate(fund.navdate) : "--" }}
                </div>
            </el-form-item>
            <el-form-item label="赎回日期：" class="form-text">
                {{ sfund.nextfinaldate ? $util.fmtDate(sfund.nextfinaldate) : "--" }}
            </el-form-item>
            <el-form-item label="赎回份额：" prop="amount" class="redemp-amount">
                <amount-input
                    v-model="fundInfo.amount"
                    :placeholder="pla"
                    prefix-icon=""
                />
                <span v-if="!isAmountAll" class="redemp-btn" v-on:click.prevent="allSell">
                    <span class="like-a">全部赎回</span>
                </span>
            </el-form-item>
            <el-form-item
                v-if="isPwdCheck"
                label="交易密码："
                prop="pwd"
                :class="{ 'form-text': fund.sign }"
            >
                <el-input
                    v-model.trim="fundInfo.pwd"
                    type="password"
                    placeholder="请输入交易密码"
                    :maxlength="16"
                />
                <span class="redemp-btn" v-on:click.prevent="$router.push({ name: 'tradepwd' })">
                    <span class="like-a">忘记密码？</span>
                </span>
            </el-form-item>
            <el-form-item>
                <div style="width: 50%">
                    <el-button
                        type="primary"
                        class="medium"
                        :disabled="time > 0"
                        v-on:click="submitInfo('fundInfo')"
                    >
                        赎回
                    </el-button>
                    <el-button class="medium" v-on:click="$router.back()">返回</el-button>
                </div>
            </el-form-item>
        </el-form>
        <fund-protocol v-model="protocol" :fund="fund" v-on:all-read="sellFund" />
        <result
            v-if="sellSuccess"
            :active="2"
            :result="result"
            v-on:return-page="reset"
            v-on:return-login="$router.push({ name: 'myorder' })"
        />
    </div>
</template>
<script>
import result from "@/components/layout/result";
import fundProtocol from "@/components/form/fundProtocol";
import datePicker from "@/components/form/datePicker.vue";
import format from "date-fns/format";
import AmountInput from "@/components/common/AmountInput.vue";
export default {
    name: "Buy",
    components: {
        result,
        fundProtocol,
        datePicker,
        AmountInput
    },
    data() {
        return {
            // 表单信息
            fundInfo: {
                amount: "",
                way: "",
                pwd: "",
                bookingdate: ""
            },
            isPwdCheck: false, // 是否校验密码
            pla: "请输入赎回份额",
            sellSuccess: false, // 购买状态
            result: {
                // 结果页面信息
                cla: "register-success",
                msg: "您的预约申请已提交成功！",
                btnMsg: "预计11月30日以11月29日净值确认份额，如遇节假日则顺延，请耐心等待",
                special: false,
                btnL: {
                    text: "继续预约",
                    event: "return-page"
                },
                btnR: {
                    text: "查看交易记录",
                    event: "return-login"
                }
            },
            query: null,
            time: 0, // 发送短信倒计时
            fund: {}, // 基金信息获取
            sfund: {},
            protocol: false,
            limit: { text: "赎回份额范围为：", min: "0", max: "0" }, // 限额
            rules: {
                // 校验规则配置
                amount: [
                    { required: true, message: "请输入赎回份额", trigger: "blur" },
                    { validator: this.amountLimit, trigger: "blur" }
                ],
                bookingdate: [{ required: true, message: "请选择赎回日期", trigger: "blur" }],
                pwd: [{ required: true, message: "请输入交易密码", trigger: "blur" }]
            },
            isAmountAll: false,
            cfmdate: "", // 确认日期
            dateSet: {
                type: "1",
                min: format(new Date(), "YYYY-MM-DD"),
                max: format(
                    new Date(new Date().getTime() + 36 * 24 * 365 * Math.pow(10, 5)),
                    "YYYY-MM-DD"
                ),
                val: "",
                text: "请选扣款日期"
            }
        };
    },
    watch: {
        "fundInfo.amount"(val) {
            this.isAmount(val);
        }
    },
    mounted() {
        this.fund = JSON.parse(sessionStorage.getItem(this.$route.name));
        this.isPwdCheck = this.$cache.getPwdCheck("25");
        this.getSellDetail();
    },
    methods: {
        // 再次购买重置表单
        reset() {
            this.sellSuccess = false;
            this.$set(this.fundInfo, "way", "");
            this.$set(this.fundInfo, "amount", "");
            this.getSellDetail();
        },
        // 处理限额
        amountLimit(rule, value, callback) {
            this.$util.validateAmountLimit(this, rule, value, callback);
        },
        // 全部取现处理
        allSell() {
            this.fundInfo.amount = Number(this.sfund.preavailbal) + "";
            this.$refs.fundInfo.validateField("amount");
            this.isAmountAll = true;
        },
        // 处理金额
        isAmount(val) {
            const _val = this.$util.checkAmount(val);
            this.$set(this.fundInfo, "amount", _val);
            if (this.fundInfo.amount === this.sfund.preavailbal) {
                this.isAmountAll = true;
            } else {
                this.isAmountAll = false;
            }
        },
        /* 提交表单数据，校验用户信息 */
        submitInfo(formName) {
            this.$children[1].index = 0;
            const _this = this;
            _this.$refs[formName].validate((valid) => {
                if (valid) {
                    /* _this.$util.getSdxProtocol(_this.fund,(res)=>{
                        _this.fund = res;
                        _this.protocol = true;
                    }); */
                    _this.sellFund(true);
                } else {
                    this.$errorScroll();
                }
            });
        },
        sellFund(val) {
            this.protocol = false;
            if (!val) return;
            const _this = this;
            // 默认参数
            let data = {
                fundcode: _this.fund.fundcode,
                investvol: _this.fundInfo.amount,
                bookingdate: _this.sfund.nextfinaldate,
                sharetype: _this.fund.sharetype,
                moneyaccount: _this.fund.moneyaccount,
                bankcode: _this.sfund.depositacct,
                channelid: _this.sfund.channelid,
                transid: _this.sfund.transactionaccountid,
                riskwarnflag: _this.fund.riskwarnflag,
                riskmismatchflag: _this.fund.riskmismatchflag,
                highriskwarnflag: _this.fund.highriskwarnflag,
                fundmismatchflag: _this.fund.fundmismatchflag,
                tradepwd: _this.$util.enc(_this.fundInfo.pwd)
            };
            let _url = "booking/sell/order";
            // 预约赎回
            _this.$util.request(_url, data, "POST").then((res) => {
                if (res.data) {
                    _this.cfmdate = res.data && res.data[0] ? res.data[0].transactioncfmdate : "";
                }
                _this.resultMes(res);
            });
        },
        // 生成确认信息
        resultMes(res) {
            if (res.data) {
                this.result.cla = "register-success";
                this.result.btnMsg = "如遇节假日则顺延，请耐心等待";
            } else {
                this.result.cla = "register-fail";
                this.result.btnMsg = "原因：" + res.msg;
            }
            this.result.msg =
                "您的预约申请受理" + (this.result.cla === "register-fail" ? "失败" : "成功");
            this.sellSuccess = true;
        },
        dateInterval(val) {
            this.fundInfo.bookingdate = val !== null ? val.replace(/-/g, "") : "";
        },
        getSellDetail() {
            // 预约赎回
            const _this = this;
            this.$util
                .request(
                    "short/asset/detail",
                    { fundcode: this.fund.fundcode, registerserialno: "" },
                    "GET"
                )
                .then((res) => {
                    if (res.data) {
                        _this.sfund = res.data[0];
                    }
                    _this.$util
                        .request("booking/sell/fundinfo", { fundcode: this.fund.fundcode }, "GET")
                        .then((res) => {
                            if (res.data) {
                                _this.$set(_this.limit, "min", res.data[0].normalmin);
                                _this.$set(
                                    _this.limit,
                                    "max",
                                    Number(_this.sfund.preavailbal) > Number(res.data[0].normalmax)
                                        ? Number(res.data[0].normalmax)
                                        : Number(_this.sfund.preavailbal)
                                );
                                _this.pla =
                                    "本次可赎回" +
                                    this.$util.fmtNum(this.limit.min) +
                                    "-" +
                                    this.$util.fmtNum(this.limit.max) +
                                    "份";
                            }
                        });
                });
        }
    }
};
</script>
<style lang="scss">
.comp-order-sell {
    padding-bottom: 30px;
    .pwdForm .el-form-item.form-text {
        margin-bottom: 10px;
    }
    .pwdForm .el-form-item.form-nor {
        margin-bottom: 20px;
    }
}
</style>
